export enum PermissionEnum {
    WriteLotteryBaseConfig = 'WriteLotteryBaseConfig',
    WriteLotteryTicket = 'WriteLotteryTicket',
    WriteLotteryWinnerConfig = 'WriteLotteryCycle',
}
